import { useState, useCallback } from 'react';

export const QUESTIONS = [
  { type: 'favorite', text: 'Which animatronic do you like more?' },
  { type: 'scarier', text: 'Which animatronic is scarier?' },
  { type: 'cuter', text: 'Which animatronic is cuter?' },
  { type: 'technical', text: 'Which animatronic is more technically impressive?' }
] as const;

export function useQuestionRotation() {
  // Keep track of remaining questions to ensure all types are used
  const [remainingQuestions, setRemainingQuestions] = useState([...QUESTIONS]);

  // Get current question (first in remaining array)
  const currentQuestion = remainingQuestions[0] || QUESTIONS[0];

  const rotateQuestion = useCallback(() => {
    setRemainingQuestions(prev => {
      // Remove current question
      const [, ...rest] = prev;
      
      // If we've used all questions, reset with a new shuffled set
      if (rest.length === 0) {
        return shuffleArray([...QUESTIONS]);
      }
      
      return rest;
    });
  }, []);

  return { currentQuestion, rotateQuestion };
}

// Fisher-Yates shuffle algorithm
function shuffleArray<T>(array: T[]): T[] {
  const newArray = [...array];
  for (let i = newArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
  }
  return newArray;
}